export const orderStore = () => {
    const GET_TYPES = /* GraphQL */ `
        query GetTypes($_incode: [String!] = "") {
            eds_order_type(
                where: {
                    deleted_date: { _is_null: true }
                    id: { _in: $_incode }
                }
            ) {
                id
                name
                active
                order_type_payment_type_source_links {
                    payment_type_id
                    payment_type {
                        id
                        name
                        default_status
                    }
                    source_id
                    paymentTypeBySecondPaymentTypeId {
                        name
                        id
                    }
                }
            }
        }
    `

    const GET_DISCOUNTS = /* GraphQL */ `
        query GetDiscounts($_nin: [bigint!] = "") {
            pds_discount(
                where: {
                    deleted_date: { _is_null: true }
                    value: { _neq: "1" }
                    rk_sifr: { _nin: $_nin, _is_null: false }
                }
            ) {
                id
                name
                value
            }
        }
    `

    const GET_STAFF_DISCOUNTS = /* GraphQL */ `
        query GetDiscounts($_in: [bigint!] = "") {
            pds_discount(
                where: {
                    deleted_date: { _is_null: true }
                    rk_sifr: { _in: $_in }
                }
            ) {
                id
                name
                value
            }
        }
    `

    const GET_REGIONS = /* GraphQL */ `
        query GetRegions {
            region(where: { deleted_date: { _is_null: true } }) {
                id
                name
                kladr_id
                latitude
                longitude
            }
        }
    `
    const GET_STATUSES = /* GraphQL */ `
        query GetDefStatus {
            eds_order_status(
                where: { active: { _eq: true } }
                order_by: { stage: asc_nulls_last }
            ) {
                id
                name
                color
            }
        }
    `
    const GET_DEF_SOURCE = /* GraphQL */ `
        query GetDefSource($sourceId: String!) {
            source(where: { id: { _eq: $sourceId } }) {
                id
                name
                recalc
            }
        }
    `

    const GET_CLOSE_OPTIONS = /* GraphQL */ `
        query GetCloseOptions {
            close_reason(where: { deleted_date: { _is_null: true } }) {
                id
                name
                order_type_id
            }
        }
    `

    const GET_STOP_LISTS_BY_RESTAURANT_ID = /* GraphQL */ `
        query GetStopList($restaurantId: uuid) {
            stop_list(
                where: {
                    deleted_date: { _is_null: true }
                    _and: { restaurant_id: { _eq: $restaurantId } }
                }
            ) {
                id
                menu_item_id
                menu_item {
                    name
                    description
                    category {
                        brand_id
                    }
                }
                restaurant_id
                deleted_date
                created_date
            }
        }
    `
    const ADD_STOP_LIST = /* GraphQL */ `
        mutation ($object: stop_list_insert_input!) {
            insert_stop_list(objects: [$object]) {
                affected_rows
            }
        }
    `
    const DELETE_STOP_LIST = /* GraphQL */ `
        mutation ($object: stop_list_set_input!, $id: uuid) {
            update_stop_list(_set: $object, where: { id: { _eq: $id } }) {
                affected_rows
            }
        }
    `
    const UPDATE_PAYMENT_DISCOUNT = /* GraphQL */ `
        mutation UpdatePayment($discount_id: uuid, $id: uuid) {
            update_payment(
                _set: { discount_id: $discount_id }
                where: { id: { _eq: $id } }
            ) {
                affected_rows
            }
        }
    `

    const GET_HAS_DISH_RESEND = /* GraphQL */ `
        query HasDishResend($orderId: uuid!) {
            dish_resend(limit: 1, where: { order_id: { _eq: $orderId } }) {
                dish_id
            }
        }
    `

    const GET_RESEND_DISHES = /* GraphQL */ `
        query GetDishResend($orderId: uuid!) {
            dish_resend(where: { order_id: { _eq: $orderId } }) {
                dish_id
                comment
                count
                operation
                dish {
                    ...dishFragment
                }
            }
        }

        fragment dishFragment on dish {
            id
            deleted_date
            comment
            menu_item_id
            ext_id
            ext_name
            children: dishes {
                id
                menu_item {
                    name
                }
            }
            dish_modifiers {
                id
                modifier {
                    name
                }
                modifier_id
            }
            menu_item {
                id
                name
                description
                composition
            }
        }
    `

    const GET_DISHES_BY_ORDER_ID = /* GraphQL */ `
        query GetDishesByOrderId($orderId: uuid!) {
            dish(
                where: {
                    order_id: { _eq: $orderId }
                    deleted_date: { _is_null: true }
                }
                order_by: { menu_item: { name: asc } }
            ) {
                id
                created_by
                created_date
                comment
                ext_name
                modifiers: dish_modifiers {
                    id
                    ext_name
                    price
                    ext_price
                    final_ext_price
                    final_price
                    count
                    id
                    modifier_id
                    dish_id
                    ext_id
                    modifier {
                        id
                        name
                    }
                }
                menu_item {
                    id
                    deleted_date
                    created_date
                    last_modified_date
                    composition
                    created_by
                    image
                    name
                    description
                    rk_uuid
                    rk_id
                }
                ext_price
                price
                count
                final_ext_price
                final_price
                parent_id
            }
        }
    `

    return {
        GET_TYPES,
        GET_DISCOUNTS,
        GET_STAFF_DISCOUNTS,
        GET_REGIONS,
        GET_STATUSES,
        GET_DEF_SOURCE,
        GET_CLOSE_OPTIONS,
        GET_STOP_LISTS_BY_RESTAURANT_ID,
        ADD_STOP_LIST,
        DELETE_STOP_LIST,
        UPDATE_PAYMENT_DISCOUNT,
        GET_HAS_DISH_RESEND,
        GET_RESEND_DISHES,
        GET_DISHES_BY_ORDER_ID,
    }
}

export const ordersStore = () => {
    const GET_ORDER_BY_ID = /* GraphQL */ `
        query GetOrderById($orderId: uuid) {
            eds_order(where: { id: { _eq: $orderId } }) {
                id
                time_type
                brand_id
                phone
                created_date
                delivered_date
                errors
                address_note
                address {
                    id
                }
                guest {
                    first_name
                    last_name
                    is_blacklisted
                    blacklist_reason
                }
                source {
                    recalc
                    name
                }
                eds_order_status {
                    name
                    color
                }
                division_id
                num
                created_by
                payments {
                    id
                    price
                    final_price
                    ext_price
                    final_ext_price
                }
                dishes(
                    where: {
                        deleted_date: { _is_null: true }
                        parent_id: { _is_null: true }
                    }
                ) {
                    id
                    deleted_date
                    count
                    price
                    ext_price
                    final_price
                    final_ext_price
                    comment
                    menu_item_id
                    ext_id
                    ext_name
                    children: dishes {
                        id
                        count
                        ext_name
                        final_price
                        final_ext_price
                        price
                        menu_item {
                            name
                        }
                    }
                    dish_modifiers {
                        id
                        price
                        ext_price
                        final_price
                        final_ext_price
                        count
                        ext_id
                        modifier {
                            name
                        }
                        modifier_id
                    }
                    menu_item {
                        id
                        name
                        description
                        composition
                    }
                }
            }
        }
    `
    const GET_STATUSES = /* GraphQL */ `
        query GetStatus {
            eds_order_status(
                where: { active: { _eq: true } }
                order_by: { stage: asc_nulls_last }
            ) {
                name
                color
                id
            }
        }
    `

    const GET_ERROR_ORDERS_COUNT = /* GraphQL */ `
        query GetStatusesCount($brand_ids: [String!]) {
            eds_order_status(
                where: {
                    active: { _eq: true }
                    name: { _eq: "Ошибка отправки" }
                }
                order_by: { stage: asc_nulls_last }
            ) {
                name
                eds_orders_aggregate(
                    where: {
                        _and: { deleted_by: { _is_null: true } }
                        brand_id: { _in: $brand_ids }
                    }
                ) {
                    aggregate {
                        count
                    }
                }
            }
        }
    `

    const GET_COURIERS = /* GraphQL */ `
        query GetCouriers {
            courier(where: { deleted_date: { _is_null: true } }) {
                name
                phone
                id
            }
        }
    `
    const UPDATE_ORDER = /* GraphQL */ `
        mutation MyMutation($id: uuid, $courier_id: uuid) {
            update_eds_order(
                where: { id: { _eq: $id } }
                _set: { courier_id: $courier_id }
            ) {
                affected_rows
            }
        }
    `
    const GET_ORDER_LOG_BY_ID = /* GraphQL */ `
        query GetOrderLog($orderId: uuid) {
            order_integration_log(
                where: { order_id: { _eq: $orderId } }
                order_by: { created_date: desc }
            ) {
                id
                order_id
                created_date
                message
                source
                type
            }
        }
    `

    const GET_SOURCE_LIST = /* GraphQL */ `
        query GetSources {
            source(where: { deleted_by: { _is_null: true } }) {
                id
                name
            }
        }
    `

    const GET_STATISTICS = /* GraphQL */ `
        query getStatistics($sd: timestamptz, $login: uuid!, $source: String!) {
            eds_order_aggregate(
                where: {
                    created_date: { _gte: $sd }
                    operator_id: { _eq: $login }
                    source: { id: { _eq: $source } }
                    eds_order_status: { name: { _eq: "Исполнен" } }
                }
            ) {
                aggregate {
                    count(columns: id)
                }
            }
        }
    `
    const GET_OPERATORS = /* GraphQL */ `
        query getUser($org: uuid!) {
            eds_user(
                where: {
                    active: { _eq: true }
                    role_eds_user_links: {
                        role: {
                            code: { _eq: "operator" }
                            org_id: { _eq: $org }
                        }
                    }
                }
                order_by: { last_name: asc, first_name: asc, middle_name: asc }
            ) {
                id
                last_name
                first_name
                middle_name
            }
        }
    `

    const GET_COOKERY_INTERVALS = /* GraphQL */ `
        query GetCookeryIntervals {
            cookery_interval(order_by: { start_time: asc }) {
                id
                name
                start_time
                end_time
            }
        }
    `

    const MARK_ORDER_FOR_IMMEDIATE_SEND = /* GraphQL */ `
        mutation MarkOrderForImmediateSend($orderId: uuid!) {
            update_eds_order(
                _set: { is_immediate_send: true }
                where: { id: { _eq: $orderId } }
            ) {
                affected_rows
            }
        }
    `

    return {
        GET_ORDER_BY_ID,
        GET_STATUSES,
        GET_ORDER_LOG_BY_ID,
        GET_SOURCE_LIST,
        GET_STATISTICS,
        GET_OPERATORS,
        GET_COURIERS,
        UPDATE_ORDER,
        GET_COOKERY_INTERVALS,
        MARK_ORDER_FOR_IMMEDIATE_SEND,
        GET_ERROR_ORDERS_COUNT,
    }
}
export const guestStore = () => {
    const ADD_GUEST = /* GraphQL */ `
        mutation addGuest($guest: guest_insert_input!) {
            insert_guest(objects: [$guest]) {
                affected_rows
                returning {
                    id
                    first_name
                    is_blacklisted
                    blacklist_reason
                    is_vip
                    last_modified_by
                    last_modified_date
                    created_by
                    last_name
                    contacts {
                        id
                        is_default
                        value: value_
                        type_id
                    }
                }
            }
        }
    `
    const GET_GUEST = /* GraphQL */ `
        query getGuest($guestId: uuid) {
            guest(where: { id: { _eq: $guestId } }) {
                id
                first_name
                is_blacklisted
                blacklist_reason
                is_vip
                last_modified_by
                last_modified_date
                last_name
                contacts {
                    id
                    value: value_
                    is_default
                    contact_type {
                        id
                        name
                    }
                }
                json_notes
            }
        }
    `

    const GET_GUEST_BY_CONTACT = `
        query getGuestByContactValues($contactValues: [String!]) {
          guest(where: {
            contacts: {
              value_: { _in: $contactValues }
            }
          }) {
            id
            first_name
            last_name
            contacts {
              id
              value: value_
              is_default
              contact_type {
                id
                name
              }
            }
          }
        }`

    const UPDATE_GUEST_NAME = /* GraphQL */ `
        mutation updateGuest(
            $id: uuid
            $first_name: String
            $date: timestamp
            $last_modified_by: String
        ) {
            update_guest(
                where: { id: { _eq: $id } }
                _set: {
                    first_name: $first_name
                    last_modified_date: $date
                    last_modified_by: $last_modified_by
                }
            ) {
                affected_rows
                returning {
                    id
                    first_name
                    last_modified_date
                    last_modified_by
                }
            }
        }
    `

    const UPDATE_GUEST_BLACKLIST = /* GraphQL */ `
        mutation updateGuest(
            $id: uuid
            $is_blacklisted: Boolean
            $blacklist_reason: String
            $date: timestamp
            $last_modified_by: String
        ) {
            update_guest(
                where: { id: { _eq: $id } }
                _set: {
                    is_blacklisted: $is_blacklisted
                    blacklist_reason: $blacklist_reason
                    last_modified_date: $date
                    last_modified_by: $last_modified_by
                }
            ) {
                affected_rows
                returning {
                    id
                    is_blacklisted
                    blacklist_reason
                    last_modified_date
                }
            }
        }
    `

    const UPDATE_GUEST_NOTES = /* GraphQL */ `
        mutation updateGuestNotes(
            $id: uuid
            $notes: jsonb
            $date: timestamp
            $last_modified_by: String
        ) {
            update_guest(
                where: { id: { _eq: $id } }
                _set: {
                    json_notes: $notes
                    last_modified_date: $date
                    last_modified_by: $last_modified_by
                }
            ) {
                affected_rows
                returning {
                    id
                    first_name
                    json_notes
                    last_modified_date
                }
            }
        }
    `

    const GET_GUEST_BY_PHONE = /* GraphQL */ `
        query GetGuestByPhone($phone: String) {
            guest(
                where: {
                    contacts: {
                        contact_type: { id: { _eq: "phone" } }
                        value_: { _ilike: $phone }
                    }
                }
            ) {
                id
                first_name
                is_vip
                is_blacklisted
                blacklist_reason
                json_notes
                contacts {
                    id
                    value: value_
                    contact_type {
                        id
                    }
                }
            }
        }
    `

    return {
        GET_GUEST,
        ADD_GUEST,
        UPDATE_GUEST_NAME,
        UPDATE_GUEST_NOTES,
        GET_GUEST_BY_PHONE,
        UPDATE_GUEST_BLACKLIST,
        GET_GUEST_BY_CONTACT,
    }
}
export const menuStore = () => {
    const GET_MENU_BY_NAME = /* GraphQL */ `
        query GetMenuItemsByBrandId(
            $brandId: String
            $q: String
            $limit: Int
            $offset: Int
            $priceTypeRkId: bigint
        ) {
            menu_item(
                limit: $limit
                offset: $offset
                where: {
                    _and: {
                        category: { brand_id: { _eq: $brandId } }
                        name: { _ilike: $q }
                        prices: {
                            price_type: { rk_id: { _eq: $priceTypeRkId } }
                        }
                    }
                }
            ) {
                id
                name
                description
                image
                category {
                    brand_id
                    name
                }
                prices(
                    where: { price_type: { rk_id: { _eq: $priceTypeRkId } } }
                ) {
                    id
                    value
                    price_type {
                        name
                        rk_id
                    }
                }
            }
            menu_item_aggregate(
                where: {
                    _and: {
                        category: { brand_id: { _eq: $brandId } }
                        name: { _ilike: $q }
                        prices: {
                            price_type: { rk_id: { _eq: $priceTypeRkId } }
                        }
                    }
                }
            ) {
                aggregate {
                    count
                }
            }
        }
    `
    const GET_MENU_BY_PAYMENT_TYPE = /* GraphQL */ `
        query GetMenuItems(
            $price_type_id: bigint
            $parameter: String
            $brandId: String
        ) {
            menu_item(
                where: {
                    _and: {
                        active: { _eq: true }
                        deleted_date: { _is_null: true }
                        menu_item_params: {
                            parameter: { code: { _eq: $parameter } }
                        }
                        prices: {
                            price_type: { rk_id: { _eq: $price_type_id } }
                        }
                        category: { brand_id: { _eq: $brandId } }
                    }
                }
            ) {
                id
                name
                description
                composition
                image
                rk_id
                category {
                    id
                    brand_id
                    name
                    rk_id
                }
                menu_item_params {
                    parameter {
                        name
                        code
                        id
                    }
                }
                modi_scheme {
                    name
                    rk_id
                    modi_scheme_details(
                        where: { deleted_date: { _is_null: true } }
                    ) {
                        deleted_date
                        rk_id
                        down_limit
                        up_limit
                        free_count
                        modi_group {
                            rk_id
                            modifiers(
                                where: { deleted_date: { _is_null: true } }
                            ) {
                                id
                                name
                                rk_id
                                deleted_date
                            }
                        }
                    }
                }
                prices(
                    where: { price_type: { rk_id: { _eq: $price_type_id } } }
                ) {
                    value
                }
            }
        }
    `

    const GET_MENU_CATEGORIES = /* GraphQL */ `
        query GetMenuCategories($brandId: String) {
            category(
                order_by: { name: asc }
                where: {
                    parent_id: { _is_null: true }
                    brand_id: { _eq: $brandId }
                }
            ) {
                rk_id
                name
                id
                categories(order_by: { name: asc }) {
                    rk_id
                    id
                    name
                    categories(order_by: { name: asc }) {
                        rk_id
                        id
                        name
                        categories(order_by: { name: asc }) {
                            rk_id
                            id
                            name
                        }
                    }
                }
            }
        }
    `

    const GET_PRICE_TYPE_ID = /* GraphQL */ `
        query GetPriceTypeID($division_id: uuid, $source_id: String = "") {
            division_price_type_source_link(
                where: {
                    _and: {
                        division_id: { _eq: $division_id }
                        source_id: { _eq: $source_id }
                    }
                }
            ) {
                price_type {
                    rk_id
                }
            }
        }
    `
    return {
        GET_MENU_BY_NAME,
        GET_MENU_BY_PAYMENT_TYPE,
        GET_MENU_CATEGORIES,
        GET_PRICE_TYPE_ID,
    }
}
export const ticketTimeStore = () => {
    const GET_REASON_TICKET_TIME = /* GraphQL */ `
        query GetTimeReason {
            ticket_time_change_reason(
                where: { deleted_date: { _is_null: true } }
            ) {
                id
                name
            }
        }
    `

    return {
        GET_REASON_TICKET_TIME,
    }
}
